/** @format */

import jQuery from 'jquery';
jQuery(function ($) {
    //
    // TNEW donation component - controls
    //
    const $tnewDonationForms = $('.c-donation-component__form');

    // Loop through each donation form block
    $tnewDonationForms.each(function () {
        const $form = $(this);
        const $tnewDonationRadios = $form.find('.c-donation-component__radio, .c-donation-component__custom [type="radio"]');
        const $tnewDonationCustomRadio = $form.find('.c-donation-component__custom [type="radio"]');
        const $tnewDonationCustomInput = $form.find('.c-donation-component__custom [type="number"]');
        const $tnewDonationCustomInputWrapper = $form.find('.c-donation-component__custom-input');
        const $tnewDonationSubmit = $form.find('[data-submit-donation]');

        // Add a change listener for every radio input within the block
        $tnewDonationRadios.each(function () {
            const $radio = $(this);
            const isCustom = $radio.closest('.c-donation-component__custom').length > 0;

            $radio.on("change", function () {
                // Reset all radio buttons and ghost buttons in the current form block
                $tnewDonationRadios.prop('checked', false).siblings('.c-btn').addClass('c-btn--ghost');

                if (isCustom) {
                    // Handle the custom donation value
                    $radio.prop('checked', true).siblings('label').removeClass('c-btn--ghost');
                    $tnewDonationCustomInput.removeAttr('tabindex').focus();

                    if ($tnewDonationCustomInput.val() > 0) {
                        $tnewDonationSubmit.removeAttr('disabled');
                    } else {
                        $tnewDonationSubmit.attr('disabled', true);
                    }
                } else {
                    // Handle predefined donation values
                    $radio.prop('checked', true).siblings('.c-btn').removeClass('c-btn--ghost');
                    $tnewDonationCustomInput.attr('tabindex', -1).val('');
                    $tnewDonationSubmit.removeAttr('disabled');
                }
            });
        });

        // When the custom input is clicked, we want to check the appropriate radio button
        $tnewDonationCustomInputWrapper.on('click', function () {
            $tnewDonationCustomInput.removeAttr('tabindex');
            $tnewDonationCustomInput.focus();
            $tnewDonationRadios.siblings('.c-btn').addClass('c-btn--ghost');
            $tnewDonationCustomRadio.siblings('label').removeClass('c-btn--ghost');
            $tnewDonationCustomRadio.prop('checked', true);
        });

        // Check whether the submit button can be enabled
        $tnewDonationCustomInput.on('input', function () {
            $tnewDonationSubmit.prop('disabled', !($(this).val() > 0));
        });

        // Handle form submission
        $form.on('submit', function (event) {
            event.preventDefault();
            const formData = $form.serializeArray();

            const customAmount = $tnewDonationCustomInput.val();

            if (customAmount) {
                let donationAmountObj = formData.find(item => item.name === 'tnew-donation-amount');
                if (donationAmountObj) {
                    donationAmountObj.value = customAmount;
                } else {
                    formData.push({ name: 'tnew-donation-amount', value: customAmount });
                }
            }

            // Fetch session key
            $.ajax({
                url: "https://secure.southbankcentre.co.uk/api/session/sessionkey/",
                method: "GET",
                xhrFields: {
                    withCredentials: true
                }
            }).done(function (result) {
                formData.push({ name: 'tnew-session-key', value: result.encryptedSessionKey });
                $.ajax({
                    url: `${wpApiSettings.root}v1/tessitura/donate/`,
                    type: 'POST',
                    headers: {
                        'X-WP-Nonce': wpApiSettings.nonce,
                    },
                    data: formData,
                    success: function (response) {
                        if (response.success) {
                            const $successContainer = $('[data-success-container]');
                            $successContainer.show();
                            window.location.href = 'https://secure.southbankcentre.co.uk/cart/details';
                        } else {
                            const $failContainer = $('[data-fail-container]');
                            if (response.data.message) {
                                $failContainer.html(`<p>${response.data.message}</p>`)
                            }
                            $failContainer.show();
                        }
                    },
                    error: function (xhr, status, error) {
                        const $failContainer = $('[data-fail-container]');
                        $failContainer.show();
                    }
                });
            });
        });
    });
});
